import { defineComponent, computed, provide, getCurrentInstance, openBlock, createElementBlock, mergeProps, renderSlot } from 'vue';
import { s as styleInject } from '../../style-inject.es-87955792.js';

var script = defineComponent({
  name: 'OrRadioGroup',
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  props: {
    modelValue: {
      type: null,
      default: null
    },
    isColumn: {
      type: Boolean,
      default: true,
      required: false
    },
    isRow: {
      type: Boolean,
      default: false,
      required: false
    },
    isDisabled: {
      type: Boolean,
      default: false,
      required: false
    },
    isUncheckable: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  setup(props) {
    const rootClasses = computed(() => ['or-radio-group', {
      ['is-column']: props.isColumn,
      ['is-row']: props.isRow
    }]);
    provide('radioGroupInstance', getCurrentInstance());
    return {
      rootClasses
    };
  }
});

function render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", mergeProps(_ctx.$attrs, {
    class: _ctx.rootClasses,
    role: "radiogroup"
  }), [renderSlot(_ctx.$slots, "default")], 16 /* FULL_PROPS */);
}

var css_248z = ".or-radio-group.is-column[data-v-3521b793] {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n}\n.or-radio-group.is-column > *[data-v-3521b793]:not(:last-child) {\n  margin-bottom: var(--s-4);\n}\n.or-radio-group.is-row[data-v-3521b793] {\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-start;\n}\n.or-radio-group.is-row > *[data-v-3521b793]:not(:last-child) {\n  margin-right: var(--s-4);\n}";
styleInject(css_248z);

script.render = render;
script.__scopeId = "data-v-3521b793";
script.__file = "src/components/or-radio-group/OrRadioGroup.vue";

export { script as OrRadioGroup };
